















































import {
    defineComponent,
    computed,
    watch,
    ref,
} from '@vue/composition-api';
import { useClickOutside } from '@app/utils/useClickOutside';
import {
    useVueRouter,
    useVuexStore,
    isMobileLayout,
} from '@superbet-group/web.lib.vue-utilities';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import { SdsButton } from '@superbet-group/web.lib.ui-components';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { AccountRoutes } from '@superbet-group/web.types';
import { DepositType } from '@models/user/enums';
import { ModalCode } from '@walletFederation/src/modals/ModalCodes';
import QrDepositForm from '@walletFederation/src/modules/quickDeposit/QrDepositForm.vue';
export default defineComponent({
    name: 'QuickDepositContainer',
    emits: ['close'],
    props: {
        isQuickDeposit: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const dropdownRef = ref<HTMLElement | null>(null);
        const { isClickOutside } = useClickOutside(dropdownRef);
        const { pushRoute, route } = useVueRouter();
        const showDropdown = ref(false);

        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const setModal = modalModule.action('setModal');
        const modalData = modalModule.getter('modalData');
        const closeModal = modalModule.action('closeModal');

        const openQuickDeposit = () => {
            setModal({
                code: ModalCode.quickDeposit,
                isClosable: true,
                data: {
                    closeBtnKey: 'wallet.deposit.modal.success.btn',
                    closeHandler: () => {
                        closeDropdown();
                    },
                },
            });
        };

        function toggleDropdown() {
            if (showDropdown.value) {
                closeDropdown();
            } else {
                showDropdown.value = true;
            }
        }

        function closeDropdown() {
            showDropdown.value = false;
        }

        function navigateToDeposit() {
            AnalyticsSDK.getInstance().log(
                'Deposit_Option_Chosen',
                {
                    whichOption: 'Header_default_button',
                },
            );
            pushRoute({ name: AccountRoutes.Deposit });
        }

        watch(isClickOutside, (newValue) => {
            if (newValue) {
                closeDropdown();
            }
        });

        watch(route, () => {
            closeDropdown();
        });

        return {
            dropdownRef,
            showDropdown,
            closeDropdown,
            toggleDropdown,
            closeModal,
            openQuickDeposit,
            isMobile: computed(() => isMobileLayout()),
            paymentType: modalData.value.type,
            navigateToDeposit,
            DepositType,
        };
    },
    components: {
        SdsButton,
        QrDepositForm,
    },
});
